import React, { Component } from 'react';
import OnboardingPhaser from './OnboardingPhaser';
import { Redirect } from 'react-router-dom';

// import AttractorTimeout from '../warning/attractorTimeout';

class TrackTheBallPhaser extends Component {
    state = {
        gameState: 1,
        redirect: false,
        restart: false,
        pauseTimeout: null
    }

    componentDidMount() {
        this.setState({
            pauseTimeout: this.setPauseTimeout(this.state.gameState)
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.gameState !== prevState.gameState) {

            // reset pulse on next step button
            const nextButton = document.querySelector('.next-onboarding-step');
            nextButton.classList.remove('pulse');
            clearTimeout(this.state.pauseTimeout);

            if (this.state.gameState !== 4) {
                // start new timeout
                this.setState({
                    pauseTimeout: this.setPauseTimeout(this.state.gameState)
                })
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(this.state.pauseTimeout);
    }

    setPauseTimeout = (step) => {
        const phaserCanvas = document.getElementById('phaser-canvas');
        const delay = this.props.config.screens.introductionScreen.ball_movement_time;

        const pauseEvent = new CustomEvent('pauseGame', {
            detail: {
                step
            }
        });

        return setTimeout(() => {
            phaserCanvas.dispatchEvent(pauseEvent);

            // Pulse next step button
            const nextButton = document.querySelector('.next-onboarding-step');
            nextButton.classList.add('pulse');
        }, delay * 1000);

    }

    nextOnboardingStep = () => {
        const { gameState } = this.state;
        let stepEvent;

        switch (gameState) {
            case 1:
                stepEvent = new Event('step2Start');
                break;
            case 2:
                stepEvent = new Event('step3Start');
                break;
            case 3:
                stepEvent = new Event('step4Start');
                break;
            case 4:
                this.setState({
                    redirect: true
                })
                break;
            default:
                break;
        }
        if (gameState !== 4) {
            const phaserCanvas = document.getElementById('phaser-canvas');
            phaserCanvas.dispatchEvent(stepEvent);

            this.setState({
                gameState: gameState + 1
            })
        }
    }

    render() {
        const config = this.props.config.screens;
        const { gameState, redirect, restart  } = this.state;

        const messageText = config.introductionScreen[`step_${gameState}_text`];

        const buttonText = gameState === 4 ? config.introductionScreen.start_button_text : config.introductionScreen.next_button_text;


        return (
            <div className="ttb-game-area introduction">

                {redirect &&
                    <Redirect push to='/executables/track-the-ball/attractor' />
                }

                {restart &&
                    <Redirect push to='/' />
                }

                <div className='message'>
                    <span>{messageText}</span>
                </div>

                <div className='next-onboarding-step'>
                    <button onClick={this.nextOnboardingStep}>
                        <span>{buttonText}</span>
                    </button>
                </div>

                <OnboardingPhaser config={config.introductionScreen} fullConfig={this.props.config} passRefUpward={this.props.passRefUpward} step={gameState}/>

                <div className="bottom-bar">
                    <button className="restart" onClick={() => this.setState({ restart: true })}>
                        {config.introductionScreen.restart_button_text}
                    </button>
                </div>
            </div>
        );
    }
}

export default TrackTheBallPhaser;
